const colorify = require("colorify.js");
$(document).ready(function () {
    $(".fancybox").fancybox({
        "padding": 0,
        "closeClick": false
    });


    $("#slides").owlCarousel({
        autoplay: true,
        autoplayTimeout: 5000,
        smartSpeed: 1000,
        loop: true,
        margin: 0,
        nav: true,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 1
            },
            1000: {
                items: 1
            }
        }
    });

    $(".bookSlider").owlCarousel({
        autoplay: true,
        autoplayTimeout: 10000,
        smartSpeed: 1000,
        loop: false,
        margin: 60,
        nav: true,
        dots: false,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 2
            },
            1000: {
                items: 3
            }
        }
    });

    $(".pageSlider").owlCarousel({
        autoplay: true,
        autoplayTimeout: 10000,
        smartSpeed: 1000,
        loop: true,
        margin: 60,
        nav: true,
        dots: false,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 2
            },
            1000: {
                items: 3
            }
        }
    });

    $("#blog").owlCarousel({
        autoplay: true,
        autoplayTimeout: 5000,
        smartSpeed: 1000,
        loop: true,
        margin: 40,
        dots: false,
        nav: false,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 2
            },
            1000: {
                items: 4
            }
        }
    });

    $("#newsSlider").owlCarousel({
        autoplay: true,
        autoplayTimeout: 5000,
        smartSpeed: 1000,
        loop: true,
        margin: 40,
        dots: false,
        nav: false,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 3
            },
            1000: {
                items: 5
            }
        }
    });

    $(".articleSlider").owlCarousel({
        autoplay: true,
        autoplayTimeout: 5000,
        smartSpeed: 1000,
        loop: true,
        margin: 40,
        dots: false,
        nav: true,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 3
            },
            1000: {
                items: 5
            }
        }
    });

    $("#detailSlide").owlCarousel({
        autoplay: false,
        loop: false,
        margin: 0,
        nav: false,
        dots: false,
        items: 1,
        mouseDrag: false,
        touchDrag: false,
        animateIn: 'fadeIn',
        animateOut: 'fadeOut'
    });

    $('.leftSlideList li').click(function () {
        $('.leftSlideList li').removeClass('active');
    });

    $('.slideBtn-1').click(function () {
        $('#detailSlide').trigger('to.owl.carousel', 0);
        $(this).addClass('active');
    });
    $('.slideBtn-2').click(function () {
        $('#detailSlide').trigger('to.owl.carousel', 1);
        $(this).addClass('active');
    });
    $('.slideBtn-3').click(function () {
        $('#detailSlide').trigger('to.owl.carousel', 2);
        $(this).addClass('active');
    });
    $('.slideBtn-4').click(function () {
        $('#detailSlide').trigger('to.owl.carousel', 3);
        $(this).addClass('active');
    });


    $(".quickNav a, .scrollMenuHeader a, .scrollSlow").on('click', function (e) {
        e.preventDefault();
        var target = $(this).attr('href');
        $('html, body').animate({
            scrollTop: ($(target).offset().top - 140)
        }, 1200);
    });

    $("#megaMenu li:nth-child(1), #menu li:nth-child(1),#megaMenu li:nth-child(3), #menu li:nth-child(3)").hover(function () {
        $(this).addClass("open");
    });
    $("#megaMenu li:nth-child(1), #menu li:nth-child(1),#megaMenu li:nth-child(3), #menu li:nth-child(3)").mouseout(function () {
        let that = this;
        setTimeout(function () {
            $(that).removeClass("open");
        }, 500, that);
    });

    $('#toggle, .overlayMobileMenu').on('click', function (e) {
        $('#toggle, .overlayMobileMenu, .mobileMenu').toggleClass("on"); //you can list several class names
        e.preventDefault();
    });

    $('.iconArrow').on('click', function () {
        if (
            $(this).next('ul').is(':visible')) {
            $(this).next('ul').slideUp('fast');
            $(this).removeClass('active');
        } else {
            $(this).closest('ul').find('.active').next('ul').slideUp('fast');
            $(this).closest('ul').find('.active').removeClass('active');
            $(this).next().slideToggle('fast');
            $(this).addClass('active');
        }
    });

    $("#same_delivery_address").change(function () {
        if ($(this).is(":checked")) {
            $("#delivery_address_container").slideUp();
        } else {
            $("#delivery_address_container").slideDown();
        }
    });

    // var $grid = $('.grid').imagesLoaded( function() {
    //
    //     $grid.isotope({
    //         itemSelector: '.grid-item',
    //         percentPosition: true,
    //         masonry: {
    //             columnWidth: '.grid-sizer',
    //             gutter: 40
    //         }
    //     });
    // });

    var $grid = $('.grid').imagesLoaded(function () {
        $grid.isotope({
            itemSelector: '.grid-item',
            percentPosition: false,
            masonry: {columnWidth: '.grid-sizer', gutter: 40}
        });
    });
    $(function () {
        var elem = $('.grid');
        var filter = elem.data('default-filter');

        // console.log(elem);
        // elem.isotope({
        //     filter: filter ? filter : '*',
        //     masonry: {
        //         columnWidth: '.grid-sizer',
        //         gutter: 40
        //     }
        // });
        $('.searchItems li a').click(function () {
            $('.searchItems .select').removeClass('select');
            $(this).addClass('select');
            var selector = $(this).data('filter');
            $('.searchGrid').isotope({
                filter: selector
            });
            return false;
        });
    });

    $('.dropdownToggle').click(function (e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).closest('.searchDropdown').toggleClass('open');
    });

    $('.dropdownMenu > li > a').click(function (e) {
        e.preventDefault();
        var clicked = $(this);
        clicked.closest('.dropdownMenu').find('.menuActive').removeClass('menuActive');
        clicked.parent('li').addClass('menuActive');
        $('.searchDropdown.open').removeClass('open');
    });

    $(document).click(function () {
        $('.searchDropdown.open').removeClass('open');
    });

    $('.presentInner').click(function () {
        $(this).toggleClass('active');
        $(this).next().toggleClass('active');
    });
    $('.showMore').click(function () {
        $(this).toggleClass('active');
        $(this).next().toggleClass('active');
    });


    // if (Modernizr.touch) {
    // } else {
    //     wow = new WOW(
    //         {
    //             animateClass: 'animated',
    //             offset:       100
    //         }
    //     );
    //     wow.init();
    // }

    setTimeout(function () {
        (function () {
            var resize = false;
            equalHeight(false, 'equalHeight');
            equalHeight(false, 'equalHeight-1');
            equalHeight(false, 'equalHeight-2');
            equalHeight(false, 'equalHeight-3');
            equalHeight(false, 'equalHeight-4');
            equalHeight(false, 'equalHeight-article-image');
            equalHeight(false, 'equalHeight-article-text');
        })();
        window.onresize = function () {
            var resize = true;
            equalHeight(resize, 'equalHeight');
            equalHeight(resize, 'equalHeight-1');
            equalHeight(resize, 'equalHeight-2');
            equalHeight(resize, 'equalHeight-3');
            equalHeight(resize, 'equalHeight-4');
            equalHeight(resize, 'equalHeight-article-image');
            equalHeight(resize, 'equalHeight-article-text');
        }
    }, 350);

    (function ($) {
        if ($(window).width() <= 960) {
            $(".navFilter").click(function () {
                $(".filterMenu").slideToggle();
            });
            $(".navTitle").click(function () {
                $(".leftMenu").slideToggle();
            });
        }
    })(jQuery);

    $("#articleCategorySelect").change(function () {
        window.location = $(this).val();
    });

    $('.toggleFaq').click(function (e) {
        e.preventDefault();
        var notthis = $('.active').not(this);
        notthis.find('.fa-caret-down').addClass('fa-caret-right').removeClass('fa-caret-down');
        notthis.toggleClass('active').next('.faqAnswer').slideToggle(300);
        $(this).toggleClass('active').next().slideToggle("fast");
        $(this).children('i').toggleClass('fa-caret-down fa-caret-right');
    });

    $('.scrollTo').click(function () {
        var menuHeight = eval($(".mainHeader").height());
        $('html, body').animate({
            scrollTop: eval($($(this).attr('data-target')).offset().top - (menuHeight + 45))
        }, 1000);
    });

    initMenu();

    if($(window).outerWidth() > 800) {
        colorify({
            container: 'colorify-main-color',
            accuracy: 100,
            padding: 0,
            give: {
                property: 'background',
                target: '.book-spine'
            }
        });
    }

    resizeHeader();
});

$(window).resize(function () {
    resizeHeader();
});

function resizeHeader(){
    var headerHeight = $(".header").outerHeight() + $(".searchArea").outerHeight();
    if($(window).outerWidth() < 1023){
        if($(".extraMenu").length){
            headerHeight += $(".extraMenu").outerHeight() - 15;
        }
        $('.content').css('margin-top', headerHeight);
    }
    else{
        headerHeight = $(".header").outerHeight();
        $('.content').css('margin-top', headerHeight);
    }
}

$(window).scroll(function () {
    var scroll = $(window).scrollTop();

    if (scroll >= 100) {
        $(".header").addClass("scroll");
    } else {
        $(".header").removeClass("scroll");
    }
});

function popup(url, w, h) {
    window.open(url, "", "width=" + w + ",height=" + h + ",scrollbars=no,toolbar=no,location=no");
}

function setCookie(name, value) {
    var expdate = new Date();
    expdate.setTime(expdate.getTime() + 1000 * 60 * 60 * 24 * 365);
    document.cookie = name + "=" + value + "; expires=" + expdate.toGMTString() + "; path=/; secure";
    document.location.reload();
}

function initMenu() {
    menu_width = $("#menuMobile .menu").width();

    $(".menu-back").click(function () {

        var _pos = $(".menu-slider").position().left + menu_width;
        var _obj = $(this).closest(".submenu");

        $(".menu-slider").stop().animate({left: _pos}, 300, function () {
            _obj.hide();
        });

        return false;
    });

    $(".menu-anchor").click(function () {
        var _d = $(this).data('menu');
        $(".submenu").each(function () {

            var _d_check = $(this).data('menu');

            if (_d_check == _d) {
                $(this).show();
                var _pos = $(".menu-slider").position().left - menu_width;

                $(".menu-slider").stop(true, true).animate({left: _pos}, 300);
                return false;
            }
        });

        return false;
    });

}

if ($(window).width() <= 960) {
    (function ($) {
        $('.extraMenu').show();
        $('.content').addClass('withExtraHeader');
        if($(".orderCol").length) {
            $(window).scroll(function () {
                var top_of_element = $(".orderCol").offset().top;
                var bottom_of_element = $(".orderCol").offset().top + $(".orderCol").outerHeight();
                var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
                var top_of_screen = $(window).scrollTop();

                if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)) {
                    $('.extraMenu').hide();
                    $('.content').removeClass('withExtraHeader');
                } else {
                    $('.extraMenu').show();
                    $('.content').addClass('withExtraHeader');
                }
            });
        }
    })(jQuery);
} else{
    $(document).scroll(function () {
        var y = $(this).scrollTop();
        if (y > 800) {
            $('.extraMenu').fadeIn();
        } else {
            $('.extraMenu').fadeOut();
        }
    });
}

equalHeight = function(resize, cssClass) {
    var elements = document.getElementsByClassName(cssClass),
        allHeights = [], i = 0;
    if (resize === true) {
        for (i = 0; i < elements.length; i++) {
            elements[i].style.height = "auto";
        }
    }
    for (i = 0; i < elements.length; i++) {
        var elementHeight = elements[i].clientHeight;
        allHeights.push(elementHeight);
    }
    for (i = 0; i < elements.length; i++) {
        elements[i].style.height = Math.max.apply(Math, allHeights) + "px";
        if (resize === false) {
            elements[i].className = elements[i].className + " show";
        }
    }
}
